/**
 * Nula breakpoint tokens (Tailwind-matching).
 *
 * Layout archetypes shift only at `md` (768px). Other breakpoints are for
 * progressive polish: `--padding-container` steps at `lg`, library
 * `--card-min-width` may tune at `sm`, typography clamp upper bounds hit
 * near `xl`.
 *
 * Consumed by:
 *   - `useBreakpoint` (JS media-query matching)
 *   - CSS custom properties in globals.css (`--breakpoint-md: 768px`)
 *
 */
export const breakpoints = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
} as const;

export type Breakpoint = keyof typeof breakpoints;

/**
 * Build a CSS media-query string for a token.
 *
 * @example
 *   mediaQuery('md', 'up')   // '(min-width: 768px)'
 *   mediaQuery('md', 'down') // '(max-width: 767.98px)'
 */
export function mediaQuery(bp: Breakpoint, direction: 'up' | 'down'): string {
  const px = breakpoints[bp];
  if (direction === 'up') return `(min-width: ${px}px)`;
  // Standard off-by-one correction: max-width is exclusive of the next min-width.
  return `(max-width: ${px - 0.02}px)`;
}
